import '../styles/style.css'
import Title from './Title'

import SwipperSkills from './SwipperSkills';

import SkillsSection from './SkillsSection';


import { useTranslation } from "react-i18next"
export default function SectionThree() {

    const { t } = useTranslation();

    
    return (
        <section className="section sec-3">
            <Title id={"skills"} title={t("title-skills.skills")} />
            
            <div className="container container-3">

                <h3 data-aos="fade-up" className="h3">{t("description-skills.text")}</h3>

                <div className="about-skills">

                    <div data-aos="fade-right">
                        <span>{t("div1.span1")}</span>
                        <span>{t("div1.span2")}</span>
                        <span>{t("div1.span3")}</span>
                    </div>

                    <div data-aos="fade-up">
                        <span>{t("div2.span1")}</span>
                        <span>{t("div2.span2")}</span>
                        <span>{t("div2.span3")}</span>
                    </div>

                    <div data-aos="fade-up">
                        <span>{t("div3.span1")}</span>
                        <span>{t("div3.span2")}</span>
                        <span>{t("div3.span3")}</span>
                    </div>

                    <div data-aos="fade-left">
                        <span>{t("div4.span1")}</span>
                        <span>{t("div4.span2")}</span>
                        <span>{t("div4.span3")}</span>
                    </div>
                </div>

                <SwipperSkills/>
                    <h3 data-aos="fade-up" className="h3-cards h3">{t("title-experience.text")}</h3>
                <SkillsSection/>

            </div>
        </section>
    )
}